import { Theme, css } from '@emotion/react';

export const headingWithAdornment = ({ spacing }: Theme) => css`
  align-items: center;
  display: flex;
  gap: ${spacing(1)}px;
`;

export const layoutContainer = ({ breakpoints, spacing }: Theme) => css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing(3)}px;

  ${breakpoints.up('sm')} {
    align-items: center;
    grid-template-columns: 1fr minmax(auto, 300px);
  }
`;

export const actionsContainer = ({ breakpoints, spacing }: Theme) => css`
  align-items: center;
  display: flex;
  gap: ${spacing(1)}px;

  ${breakpoints.up('sm')} {
    a:first-of-type {
      flex: 1;
    }
  }
`;

/**
 * The apple wallet button is an SVG provided by Apple
 * https://developer.apple.com/wallet/add-to-apple-wallet-guidelines/
 *
 * The sizing applied here aligns the display with our medium Omakase buttons
 */
export const appleWalletButton = css`
  display: block;
  height: 44px;
  max-width: 140px;
  width: 100%;

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;
